import locationData from "../data/philippineLocations.json";

export const PHILIPPINE_LOCATION_DATA_VERSION = locationData.version;

const provinceRecords = Array.isArray(locationData.provinces) ? locationData.provinces : [];
const provinceByName = new Map(
  provinceRecords.map((province) => [province.name, province])
);

function includeSavedValue(options, savedValue) {
  const normalizedSavedValue = String(savedValue || "").trim();
  if (!normalizedSavedValue) return options;
  if (options.some((option) => option.value === normalizedSavedValue)) return options;

  return [
    { value: normalizedSavedValue, label: normalizedSavedValue },
    ...options,
  ];
}

export function getPhilippineProvinceOptions(region = "", savedValue = "") {
  const normalizedRegion = String(region || "").trim();
  const options = provinceRecords
    .filter((province) => !normalizedRegion || province.regions.includes(normalizedRegion))
    .map((province) => ({ value: province.name, label: province.name }));

  return includeSavedValue(options, savedValue);
}

export function getPhilippineCityMunicipalityOptions(province = "", savedValue = "") {
  const normalizedProvince = String(province || "").trim();
  const provinceRecord = provinceByName.get(normalizedProvince);
  const options = (provinceRecord?.citiesMunicipalities || []).map((name) => ({
    value: name,
    label: name,
  }));

  return includeSavedValue(options, savedValue);
}

export function getPhilippineLocationCounts() {
  return {
    provinces: provinceRecords.length,
    citiesMunicipalities: provinceRecords.reduce(
      (total, province) => total + province.citiesMunicipalities.length,
      0
    ),
  };
}
